export const vuemetaMixin = {
  data() {
    return {
      siteUrl: 'https://gianluca-lomarco.web.app',
      siteName: 'Gianluca Lomarco',
    }
  }
}